import { Button } from "@/components/ui/button";
import acLogo from "@/assets/black-logo.webp";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section 
      id="home" 
      className="min-h-svh flex items-center justify-center relative overflow-hidden pt-28 pb-12" 
      style={{ minHeight: '-webkit-fill-available' }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-primary/70 via-transparent to-transparent" />
      <div className="max-w-5xl mx-auto px-4 text-center relative z-10">
        {/* LCP OPTIMIZATION: 
           1. fetchpriority="high" tells the browser this is the most important image.
           2. loading="eager" ensures it's not deferred.
           3. width/height avoids layout shifts (CLS).
        */}
        <img
          src={acLogo}
          alt="ATC Logo"
          width={220} // Match the 220px maximum scale
          height={220}
          fetchPriority="high" 
          loading="eager"
          className="mx-auto mb-8 object-contain aspect-square animate-in fade-in zoom-in duration-700 fill-mode-both"
          style={{ width: 'clamp(8rem, 50vw, 500px)' }}
        />

        <p 
          className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto mb-10 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-200 fill-mode-both"
        >
          Revolutionize your real estate transaction process. Save time, reduce costs, and alleviate stress.
        </p>
        
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500 fill-mode-both">
          <Button
            size="lg"
            className="text-lg px-10 py-6 shadow-lg hover:scale-105 transition-transform font-semibold"
            onClick={() => navigate("/get-started")}
          >
            Get Started
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;